const phoneHead = require(`@/assets/img/phone-head.png`)

const getters = {
  status(state) {
    return state.status
  },
  type(state) {
    return state.type
  },
  corpId(state) {
    return state.corpId
  },
  channelInfo(state) {
    const info = JSON.parse(JSON.stringify(state.channelInfo || {}))
    if (!info.defaultHead) {
      info.defaultHead = phoneHead
    }
    return info
  },
  menuList(state) {
    let menuList = state.channelInfo.menuList || []
    if (!menuList.length) {
      menuList = [
        {
          title: '聊天互动',
          type: 'chat',
          id: null
        }
      ]
    }
    return menuList
  },
  advertTop(state) {
    return state.advertTop
  },
  advertMiddle(state) {
    return state.advertMiddle
  },
  userInfo(state) {
    return state.userInfo
  },
  jumpUrls(state) {
    const info = state.channelInfo
    const uin = info.uin
    const id = info.id
    const backUrl = encodeURIComponent(window.location.href)
    const origin =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}:3004`
        : window.location.origin
    return {
      login: `${origin}/my/login?uin=${uin}&backUrl=${backUrl}`,
      login_binding: `${origin}/my/login/binding?uin=${uin}&backUrl=${backUrl}`,
      center: `${origin}/my/center?uin=${uin}&backUrl=${backUrl}`,
      center_wallet: `${origin}/my/center/wallet/cash?uin=${uin}&backUrl=${backUrl}`,
      pay_redPacket: `${origin}/my/pay/redPacket?uin=${uin}&id=${id}&backUrl=${backUrl}`
    }
  },
  // js-bridge v2 存在于cookie中的受限模式状态
  isOpenLimitedMode() {
    try {
      return window._gdyJsConfig.isOpenLimitedMode
    } catch (e) {
      return false
    }
  },
  globalSetting(state) {
    return state.globalSetting
  }
}
export default getters
